import React from 'react';
import { Zap, Target, CheckCircle } from 'lucide-react';
import { mockData } from '../../mock';

const iconMap = {
  'zap': Zap,
  'target': Target,
  'check-circle': CheckCircle
};

const WhyChooseSection = () => {
  return (
    <section className="py-24 px-6 bg-[#0a0a0a] relative overflow-hidden">
      {/* Background effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#2F6BFF]/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">Why Choose MeshWeb</h2>
          <p className="text-[#9AA3B2] text-lg max-w-2xl mx-auto">
            Professional websites delivered fast, designed for results
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {mockData.whyChoose.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group relative p-8 rounded-2xl bg-gradient-to-br from-[#1a1a1a] to-[#111111] border border-[#2F6BFF]/10 hover:border-[#2F6BFF]/30 transition-all duration-300 hover:scale-105"
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#2F6BFF]/20 to-[#4DA3FF]/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="h-7 w-7 text-[#4DA3FF]" />
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                <p className="text-[#9AA3B2] leading-relaxed">{feature.description}</p>
                
                {/* Hover glow effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#2F6BFF]/0 to-[#4DA3FF]/0 group-hover:from-[#2F6BFF]/5 group-hover:to-[#4DA3FF]/5 transition-all duration-300 pointer-events-none"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
